
export const LoginCheck =  (Token) => {
    return new Promise((resolve,reject) => {
        const myHeaders = new Headers();
       
        
        myHeaders.append("Authorization", `Bearer ${Token}`)
 
    
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          redirect: 'follow'
        };
    
        fetch(`https://conta-api.solucioneskmp.com/Facturas/CheckLogin`, requestOptions)
          .then(response => response.json())
          .then(result => resolve(result))
          .catch(error => reject( error));
    })}

    export const Log =  (data) => {
      return new Promise((resolve,reject) => {
          const myHeaders = new Headers();
          var formdata = new FormData();
          formdata.append("mail",data.mail);
          formdata.append("pass",data.pass);
          formdata.append("check",data.check);
          var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
          };
      
          fetch(`https://conta-api.solucioneskmp.com/Facturas/Login`, requestOptions)
            .then(response => response.json())
            .then(result => resolve(result))
            .catch(error => reject( error));
      })}

   